import React, { useState, useEffect } from 'react'
import List from './List'
import ListNew from './Listnew'
import Add from './Add'
import AddNew from './AddNew'
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
export default function Main({ handleTab,data }) {
    const [tab, setTab] = useState("list");
    const [editData,setEditData] =useState({})

    const handleType = (type,datas) => {
        const obj = {...datas,type:data?.type}
        setEditData(obj)
        setTimeout(()=>{setTab(type)},0)
    }

    const handleBackbtn =()=>{
        if(tab === "list"){
            handleTab("list",'')
        }else{
            handleType("list","")
        }
    }
    return (
        <>
            <div className="container-fluid">
                <div onClick={(e) => handleBackbtn(e)} style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                    <h5 style={{ cursor: 'pointer' }}>Back</h5>
                </div>
                {
                    tab === "list" ?
                        // <List  Detaildata={data} handleType={handleType}/>
                        <ListNew  Detaildata={data} handleType={handleType}/>
                        : ''}
                {
                    tab === "addSubcategory" || tab === "editSubcategory" ?
                        // <Add  Detaildata={tab === "editSubcategory" ? editData : data} handleType={handleType}/>
                        <AddNew  Detaildata={tab === "editSubcategory" ? editData : data} handleType={handleType}/>
                        : ''}

            </div>
        </>
    )
}
